import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import App from './App';

// first set the tab if there is a hash
if (window.location.hash) {
  // first remove the has
  const hash = window.location.hash.replace('#', '')
  if (hash === 'commercial' || hash === 'residential' || hash === 'sales') window.gwSearch.activeTab = hash  
}

const container = document.getElementById('goodwins-search-app')
if (container !== null) {
  ReactDOM.render(<App />, container);
}



// WEBPACK FOOTER //
// ./src/index.js